import Box from "@/common/components/Box";
import { cn } from "@/common/utils/cn";
import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import { MaintenanceForwardingDirectiveEntryStatus, MaintenanceForwardingSectionsProps } from "../../../../../features/forwardings/types/maintenanceForwarding.type";
import DirectiveEntryDiagnosticEntryCompleted from "./Content/DiagnosticEntryCompleted";
import DirectiveEntryDiagnosticEntriesAdvance from "./DianosticEntries/Advance";
import DirectiveEntryDiagnosticEntriesDisapprove from "./DianosticEntries/Disapprove";
import DirectiveEntryDiagnosticEntriesRegress from "./DianosticEntries/Regress";

const MaintenanceWorkflowForwardinDirectiveEntrySection = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  const queryClient = useQueryClient();

  const forwardingState = queryClient.getQueryState(['maintenanceForwarding', forwarding.id]);

  const isDiagnosticEntryPending = useMemo(() => {
    return [
      MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart,
      MaintenanceForwardingDirectiveEntryStatus.InProgress,
      MaintenanceForwardingDirectiveEntryStatus.AwaitingClientReview,
    ].includes(forwarding.directive_entry?.status);
  }, [forwardingState?.dataUpdatedAt]);

  const isDiagnosticEntryCompleted = useMemo(() => {
 return ![
      MaintenanceForwardingDirectiveEntryStatus.Pending,
      MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart,
      MaintenanceForwardingDirectiveEntryStatus.InProgress,
    ].includes(forwarding.directive_entry.status) || (
        forwarding.directive_entry.status === MaintenanceForwardingDirectiveEntryStatus.InProgress &&
        forwarding.directive_entry?.last_review?.state === 'disapproved'
      );
  }, [forwardingState?.dataUpdatedAt]);

  const isDiagnosticEntryAwaitingClientReview = useMemo(() => {
    return [
      MaintenanceForwardingDirectiveEntryStatus.AwaitingClientReview
    ].includes(forwarding.directive_entry?.status);
  }, [forwardingState?.dataUpdateCount]);

  const isDiagnosticEntryDisapproved = useMemo(() => {
    return forwarding.directive_entry?.last_review?.state === 'disapproved';
  }, [forwardingState?.dataUpdateCount]);

  return (
    <Box className={cn(
      'p-4 flex flex-col gap-4',
      isDiagnosticEntryAwaitingClientReview && !isDiagnosticEntryDisapproved && 'bg-yellow-op-2',
    )}>
      <div className="flex items-center justify-between flex-wrap">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">
            Diagnóstico e orçamento
          </p>

          {isDiagnosticEntryPending && (
            <p className="text-warning text-xs">
              Aguardando análise do diagnóstico e orçamento
            </p>
          )}
        </div>

        {isDiagnosticEntryAwaitingClientReview && (
          <div className="flex items-center gap-3">
            {isDiagnosticEntryDisapproved ? (
              <DirectiveEntryDiagnosticEntriesRegress
                forwarding={forwarding}
              />
            ) : (
              <DirectiveEntryDiagnosticEntriesDisapprove
                forwarding={forwarding}
              />
            )}

            <DirectiveEntryDiagnosticEntriesAdvance
              forwarding={forwarding}
            />
          </div>
        )}
      </div>

      {isDiagnosticEntryCompleted && (
        <DirectiveEntryDiagnosticEntryCompleted forwarding={forwarding} />
      )}
    </Box>
  )
}

export default MaintenanceWorkflowForwardinDirectiveEntrySection;
